import { render, staticRenderFns } from "./DiagCourseList.vue?vue&type=template&id=38cb66e0&scoped=true&"
import script from "./DiagCourseList.vue?vue&type=script&lang=js&"
export * from "./DiagCourseList.vue?vue&type=script&lang=js&"
import style0 from "./DiagCourseList.vue?vue&type=style&index=0&id=38cb66e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cb66e0",
  null
  
)

export default component.exports